import React from "react";
import assetHomeIcon from "../../../../../assets/images/asset.png";
import debtImage from "../../../../../assets/images/debt.png";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";

export const DisabilityLiabilityCard = ({
  loanAmount,
  monetaryValue,
  loading,
  Icon,
  width,
}) => {
  const details = [
    {
      Name: "Total Assets",
      icon: assetHomeIcon,
      amount: monetaryValue ? parseFloat(monetaryValue) : 0,
    },
    {
      Name: "Total liabilities",
      icon: debtImage,
      amount: loanAmount ? parseFloat(loanAmount) : 0,
    },
  ];
  return (
    <div className="loanCardDisability" style={{ position: "relative",width:width ? width: "" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <img width={66} height={56} src={Icon} alt={"assets"}></img>
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <span className="loanCardDisabilityHeading">
            Assets and liabilities
          </span>
          <ToolTipCreator name={"Disability_Liabilities"} iconWhite={true}/>
        </div>
      </div>
      <div className="liliability-amounts-container">
        <div className="disbalityLoanrows">
          {details.map((item, index) => (
            <div key={index} className="loanCardDisabilityRow">
              <img src={item.icon} width={96} alt="asset" />

              <div className="loanCardDisabilityHeading">
                <span>{item.Name}</span>
                <span>
                  $
                  {item.amount &&
                    item.amount
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
